module.exports = __webpack_public_path__ + "static/media/MD_HC_SamplesInfoDetails.0a961707.tsv";